import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonContent, IonHeader, IonModal } from '@ionic/react'
import { tipMobx } from '@mobxStore'
import PercentTipItem from './PercentTipItem'
import AmountTipItem from './AmountTipItem'
import NoTipTipItem from './NoTipTipItem'
import CustomTipItem from './CustomTipItem'
import './index.scss'

interface IProps {
  resolve?: () => void;
  reject?: () => void;
}

const SelectTipModal: FC<IProps> = ({ resolve, reject }) => {
  return (
    <IonModal
      isOpen
      cssClass='select-tip-modal'
      onDidDismiss={reject}
    >
      <IonHeader>
        <div className='select-tip-header'>
          <span>{i18n.t('pay.selectTip')}</span>
          <i className='iconfont icon-close' data-cypid='selectTipModalClose' onClick={reject} />
        </div>
      </IonHeader>
      <IonContent>
        <ul className='option-list'>
          {tipMobx.tipOptions.map((x, i) => {
            if (x.type === 'percent') {
              return <PercentTipItem key={i} option={x} onSelected={resolve} />
            } else if (x.type === 'amount') {
              return <AmountTipItem key={i} option={x} onSelected={resolve} />
            } else if (x.type === 'noTip') {
              return <NoTipTipItem key={i} option={x} onSelected={resolve} />
            } else if (x.type === 'custom') {
              return <CustomTipItem key={i} option={x} onSelected={resolve} />
            }
          })}
        </ul>
      </IonContent>
    </IonModal>
  )
}

export default observer(SelectTipModal)
